module.exports = __webpack_public_path__ + "img/dankoff_loader.da1b63a4.svg";